export default [
  {
    title: 'breadcrumb.senior',
    route: 'list-senior',
    icon: 'UserIcon',
    resource: 'senior',
    action: 'read',
  },
]
